




































































































import Vue from 'vue'
import Component from 'vue-class-component'

import { projectVariables } from '../../../../../../../../../../service-for-environment-variables/environment-variables-type-1-general-variables/general-variables-type-1-project-variables/project-variables-1-introduction'

import { YOUR_ACCOUNT_PAGE_INFORMATION } from '../../../../../../../../../../service-for-environment-variables/environment-variables-type-1-general-variables/general-variables-type-1-project-variables/project-variables-2-customer-website-page-information'

import DigitalCurrency1DigitalCurrencySymbol from '../../../../html-components-type-1-basic/basic-type-2-digital-currency/digital-currency-1-digital-currency-symbol.vue'

import PersonalInformationResourceItem1AccountInformationSettings from './service-for-personal-information-resource-item/personal-information-resource-item-1-account-information-settings.vue'
// import PersonalInformationResourceItem2TransactionInformationSettings from './service-for-personal-information-resource-item/personal-information-resource-item-2-transaction-information-settings.vue'
// import PersonalInformationResourceItem3ProductResourceInformationSettings from './service-for-personal-information-resource-item/personal-information-resource-item-3-product-resource-information-settings.vue'
// import PersonalInformationResourceItem4JobEmploymentInformationSettings from './service-for-personal-information-resource-item/personal-information-resource-item-4-job-employment-information-settings.vue'
import PersonalInformationResourceItem5CurrencyExchangeInformationSettings from './service-for-personal-information-resource-item/personal-information-resource-item-5-currency-exchange-information-settings.vue'
// import PersonalInformationResourceItem6DigitalCurrencyAlternativeInformationSettings from './service-for-personal-information-resource-item/personal-information-resource-item-6-digital-currency-alternative-information-settings.vue'


@Component({
  components: {
    DigitalCurrency1DigitalCurrencySymbol,
    PersonalInformationResourceItem1AccountInformationSettings,
    // PersonalInformationResourceItem2TransactionInformationSettings,
    // PersonalInformationResourceItem3ProductResourceInformationSettings,
    // PersonalInformationResourceItem4JobEmploymentInformationSettings,
    PersonalInformationResourceItem5CurrencyExchangeInformationSettings
    // PersonalInformationResourceItem6DigitalCurrencyAlternativeInformationSettings
  }
})
class SettingsHelperComponents4PersonalInformationResourceItem extends Vue {

  projectName: string = projectVariables.projectName
  digitalCurrencyName: string = projectVariables.digitalCurrencyName

  YOUR_ACCOUNT_PAGE_INFORMATION = YOUR_ACCOUNT_PAGE_INFORMATION

  // a list of the indexes of the panels that are open by default
  // [0, 2, 3, 1] means all 4 panels are expanded
  isExandedPanelList: number[] = []

  isOpenStatistics: number = 0
}

export default SettingsHelperComponents4PersonalInformationResourceItem

